import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Duty } from '../../backend/backendapi';
import { massEditDuty } from '../dutyui.util';
import Toasted from 'vue-toasted';

Vue.use(Toasted, { duration: 2000 });

@Component({
    name: 'AdvancedNotificationModal',
    components: {}
})
export default class AdvancedNotificationModal extends Vue {
    @Prop({ required: true })
    readonly duties!: Duty[];

    private advancedReminderHours: number = 0;

    open(): void {
        $(this.$refs.modal!).modal('show');
        setTimeout(() => (this.$refs.dropdown as HTMLElement).focus(), 500);
        this.selectMostCommonValue();
    }

    dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private async save(): Promise<void> {
        const stats = await massEditDuty(this.duties, (dutyCreate) => {
            dutyCreate.duty.advancedReminderHours = this.advancedReminderHours;
        }, this.$toasted, this.$i18n);
        this.$emit('saved', stats);
        if (stats.failed === 0) {
            this.dismiss();
        }
    }

    private selectMostCommonValue(): void {
        //compute most selected value among the duties
        const occur = this.duties.map(e => e.advancedReminderHours)
            .reduce((acc, v) => acc.set(v, (acc.get(v) ?? 0) + 1), new Map<number, number>()); //count occurrences of values
        const sorted = Array.from(occur.entries()).sort((l, r) => r[1] - l[1]);//sort desc by value

        if (sorted.length > 0) {
            this.advancedReminderHours = sorted[0][0];//use most selected value among the duties
        } else {
            this.advancedReminderHours = 0;
        }
    }
}